// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + ({"854":"pdfjs","973":"pdfjs-worker"}[chunkId] || chunkId) + "." + {"749":"5b1cd72d","854":"de440d69","973":"28acd6b7"}[chunkId] + ".chunk.js";
};